import { isRunningInBrowser } from "../components/App";
import { Citation } from "../helpers/Models";
import { extension_endpoint } from "../utils/constants";

export const url_get_existing_citations = extension_endpoint + "/get_existing_citations";

const filterDuplicateCitations = (citations: Citation[]) => {
  const seen: { [key: string]: boolean } = {};
  const filteredCitations: Citation[] = [];
  citations.forEach((citation) => {
    if (!seen[citation.text]) {
      filteredCitations.push(citation);
      seen[citation.text] = true;
    }
  });
  return filteredCitations;
};

export const getExistingCitations = async ({
  getToken,
}: {
  getToken: () => Promise<string | null>;
}): Promise<Citation[]> => {
  return await Word.run(async (context) => {
    const token = await getToken();
    let result: Citation[] = [];
    if (!token && !isRunningInBrowser()) {
      console.debug("getExistingCitations no token");
      return result;
    }
    const headers: Record<string, string> = {};
    headers["Content-Type"] = "application/json";
    headers["Authorization"] = `Bearer ${token}`;

    try {
      let range = context.document.body;
      range.load("text");
      await context.sync();
      let rangeText = range?.text;
      await context.sync();
      const documentText = rangeText?.trim();

      if (!documentText) {
        console.debug("getExistingCitations call -- no documentText");
        return result;
      }
      const input = {
        document: documentText,
      };

      const response = await fetch(url_get_existing_citations, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(input),
      });
      const data = await response.json();
      const citationsList: Array<any> = data["citations"];
      if (citationsList?.length < 1) return result;
      const citations: Array<Citation> = citationsList.map((item) => {
        return item as Citation;
      });
      const filteredCitations = filterDuplicateCitations(citations);
      result = filteredCitations;
    } catch (error) {
      console.log("getExistingCitations error", error);
    }
    return result;
  });
};
